import script from "./SpringboardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpringboardView.vue?vue&type=script&setup=true&lang=ts"

import "./SpringboardView.vue?vue&type=style&index=0&id=7b593caa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b593caa"]])

export default __exports__